import LandingPage from "./components/LandingPage";
import {useRoutes} from "react-router-dom";
import Login from "./components/Login";
import {AuthProvider} from "./contexts/authContext";
import SignUp from "./components/SignUp";
import NewCustomer from "./components/NewCustomer";
import {DarkModeProvider} from "./contexts/darkModeContext";
import SplashScreen from "./components/SplashScreen";
import KissUpload from "./components/KissUpload";
import LandingCustomers from "./components/LandingCustomers";
import {NotificationProvider} from "./components/Notifications/NotificationProvider";
import Soil from "./components/Soil";
import Content from "./components/Content";

function App() {
  const routesArray = [
    {
      path: "*",
      element: <LandingPage />,
    },
    {
      path: "/Login",
      element: <Login />,
    },
    {
      path: "/SignUp",
      element: <SignUp />,
    },
    {
      path: "/NewCustomer",
      element: <NewCustomer />,
    },
    {
      path: "/SplashScreen",
      element: <SplashScreen />,
    },
    {
      path: "/KissUpload",
      element: <KissUpload />,
    },
    {
      path: "/Soil",
      element: <Soil />,
    },
    {
      path: "/Content",
      element: <Content />,
    },
    {
      path: "/Customer",
      element: <LandingCustomers />,
    },
  ];

  const routesElement = useRoutes(routesArray);

  return (

      <DarkModeProvider>
        <AuthProvider>
          <NotificationProvider>
            <div className="fixed font-mono w-full h-dvh flex flex-col">{routesElement}</div>
          </NotificationProvider>
        </AuthProvider>
      </DarkModeProvider>
  
  );
}

export default App;
